import { useContext } from 'react';
import { systemCode, xs_instantSessionToken, xs_languageCode, xs_sessionToken } from '../..';
import { appConfig } from '../../appConfig';
import { getLabel } from '../../data/labels';
import { UserContext } from '../../data/betslip/UserConf';

export default function useOpenRoulette(rConf) {
	const user = useContext(UserContext)?.getUser() ?? null;

	let rouletteUrl = '';
    if (rConf.lurl?.length > 0) {
    	let token = xs_sessionToken;
    	if(rConf.lurl.indexOf("instantGame") >= 0 && xs_instantSessionToken){
    		token = xs_instantSessionToken;
    	}
		rouletteUrl = rConf.lurl.replace(/{{LANGUAGE}}/g, xs_languageCode.toLowerCase())
		                         .replace(/{{TOKEN}}/g, token)
		                         .replace(/{{SYSTEM_CODE}}/g, systemCode);
	}

	const mobilePosition = rConf?.rmp ?? '';
	// showing the button over the TOP one
	if (mobilePosition === 'OVER_TOP_BUTTON') {
		const roulette = document.getElementById('roulette-button-on-body');
		if (roulette != null) {
			const attrBool = roulette.getAttribute('showed');
			const showed = attrBool === 'true';
			if (!showed) {
				roulette.setAttribute('showed', true);
                roulette.setAttribute('style', 'display: flex;');

				const label = getLabel('roulette.title', 'Live Roulette');
				const labelEl = document.getElementById('#roulette-button-on-body-label');
                if (labelEl) {
                    labelEl.html = label;
                }
			}
		}
	}

	function openRoulette() {
    	if (user.logged) {
            if (appConfig && (appConfig.IS_APP_IOS || appConfig.IS_APP_ANDROID)) {
                window.location.href = rouletteUrl;
            } else {
                window.open(rouletteUrl);
            }
    	} else {
    		document.getElementById('cg-contoButton')?.click();
    	}
    }

	return openRoulette;
}
